module.exports = __webpack_public_path__ + "static/img/6.57696ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/6.png
// module id = 7snw
// module chunks = 0